export default {
    "Year": "2022",
    "Company Name": "苏州矩步引领软件科技有限公司",
    "ICP": "苏ICP备20028789号-4",
    "Product Name": "PDF格式转换器",
    "HomePics": [
        {
            name: "a",
            pic: require('../images/home-1.jpg'),
            fillColor: "#000"
        },
        {
            name: "b",
            pic: require('../images/home-2.jpg'),
            fillColor: "#FFF"
        },
        {
            name: "c",
            pic: require('../images/home-3.jpg'),
            fillColor: "#CCCCCC"
        },
        {
            name: "d",
            pic: require('../images/home-4.jpg'),
            fillColor: "#FFF"
        },
    ],
    "Mail address": "江苏省苏州市高新区金狮大厦2515室",
    "Phone": "17751262870",
    "Html With Markdown": {
        // 示列：require("./AboutDeal.md") 用来替换默认模板内容
        // 如果md里面没有内容效果等同于false
        AboutDeal: false,
        UserPrivacy: false
    }
}